export default __webpack_public_path__ + "static/media/stream.a497f095.jpg";